var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlayFilledAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.96592 16.25C3.8092 16.25 3.65889 16.1929 3.54808 16.0913C3.43726 15.9898 3.375 15.852 3.375 15.7083V3.79158C3.37502 3.69745 3.40179 3.60495 3.45269 3.5232C3.50358 3.44145 3.57683 3.37327 3.66523 3.32537C3.75363 3.27747 3.85411 3.25152 3.95679 3.25006C4.05946 3.24861 4.16077 3.27171 4.25074 3.31707L16.0691 9.27545C16.1617 9.32221 16.239 9.39091 16.2928 9.47437C16.3466 9.55783 16.375 9.65301 16.375 9.74995C16.375 9.8469 16.3466 9.94208 16.2928 10.0255C16.239 10.109 16.1617 10.1777 16.0691 10.2245L4.25074 16.1828C4.16349 16.2269 4.06552 16.25 3.96592 16.25Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayFilledAlt);
export default __webpack_public_path__ + "static/media/play-filled-alt.2ff4dd2c8cf09242cb2ce8310f26a763.svg";
export { ForwardRef as ReactComponent };